<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon"
    viewBox="0 0 24 24"
  >
    <path d="M13 11H20V13H13V20H11V13H4V11H11V4H13V11Z" />
  </svg>
</template>

<script>
export default {
  name: 'IconPlus',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: inherit;
  flex-shrink: 0;
}
</style>
